<template>
  <div>
    <div id="user-data">
      <div class="flex flex-wrap-reverse items-center data-list-btn-container">
        <vs-button icon-pack="feather" type="border" color="warning" icon="icon-activity" class="p-3 mb-4 mr-4 "
          @click="refreshDb">Refresh Materialized
        </vs-button>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">

          <vx-card title="Clean People DB" class="mb-base">
            <template>
              <div id="data-list-list-view" class="data-list-container">
                <vs-table ref="table" :data="similarity">
                  <template slot="thead">
                    <vs-th sort-key="p1">Person 1</vs-th>
                    <vs-th sort-key="p2">Person 2</vs-th>
                    <vs-th sort-key="Pct">Similarity</vs-th>
                    <vs-th>Keep 1</vs-th>
                    <vs-th>Keep 2</vs-th>
                  </template>

                  <template>
                    <tbody>
                      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in similarity">
                        <vs-td>#{{ tr.id1 }}<br />VAT No: {{ tr.vat1 }}<br />Tel: {{ tr.tel1 }}<br />Name: {{ tr.name1
                          }}<br />N Operation:{{ tr.count1
                          }}</vs-td>
                        <vs-td>#{{ tr.id2 }}<br />VAT No: {{ tr.vat2 }}<br />Tel: {{ tr.tel2 }}<br />Name: {{ tr.name2
                          }}<br />N Operation:{{ tr.count2
                          }}</vs-td>
                        <vs-td>{{ (parseFloat(tr.sim_score) * 100).toFixed(0) }}</vs-td>
                        <vs-td>
                          <vs-button :color="tr.keep1Confirmed ? 'success' : 'danger'"
                            @click="makeChanges(tr.id1, tr.id2, 'keep1', indextr)">
                            Keep 1
                          </vs-button>
                        </vs-td>
                        <vs-td>
                          <vs-button :color="tr.keep2Confirmed ? 'success' : 'danger'"
                            @click="makeChanges(tr.id2, tr.id1, 'keep2', indextr)">
                            Keep 2
                          </vs-button>
                        </vs-td>
                      </vs-tr>
                    </tbody>
                  </template>
                </vs-table>
              </div>
            </template>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import axios from "@/axios.js";


export default {
  data() {
    return {
      similarity: [],
      items: {}
    };
  },
  methods: {
    async postdata(keepType,index) {
      axios
        .post("cleandb/post", this.items)
        .then((response) => {
          if (keepType === 'keep1') {
            this.similarity[index].keep1Confirmed = true;
          } else if (keepType === 'keep2') {
            this.similarity[index].keep2Confirmed = true;
          }
        });
    },
    async makeChanges(idnew, idold, keepType, index) {
      this.items = {
        idnew: idnew,
        idold: idold
      };
      this.$vs.dialog({
        type: "confirm", // Warning type for critical actions
        color: "danger", // Red color to emphasize the severity
        title: "Warning: Irreversible Operation ("+keepType+")",
        text: "Are you sure you want to proceed? This action will permanently delete the selected person, and all their operations will be transferred to the remaining person. This operation cannot be undone.",
        accept: () => {
          this.postdata(keepType,index);
        },
        acceptText: "Yes!",
      });
    },
    async refreshDb() {
      this.$vs.loading();
      axios
        .get("cleandb/refresh")
        .then((response) => {
          this.GetSimilarity()
        });
    },
    async GetSimilarity() {
      this.$vs.loading();
      axios
        .get("cleandb/data")
        .then((response) => {
          // Ajoutez les propriétés de confirmation à chaque élément
          this.similarity = response.data.map(item => ({
            ...item,
            keep1Confirmed: false,
            keep2Confirmed: false
          }));
          this.$vs.loading.close();
        });
    },
    moment: function () {
      return moment();
    },
    getActiveColors(status) {
      if (status === true) return "primary";
      if (status === false) return "danger";
      return "warning";
    },
  },
  created() {
    this.refreshDb()
  },
};
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

@media screen and (min-width: 1201px) and (max-width: 1211px),
only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }
}
</style>
